// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root___XuaE","approved":"Status_approved__Ml1ki","rejected":"Status_rejected__39dEc","expired":"Status_expired__3IYNX","label":"Status_label__eazM8"};